module.exports = __webpack_public_path__ + "static/media/risk-realm-bg.6b438cfa.svg";